var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-menu-component",
      class: { hide: !_vm.isOpenExtendMenu },
    },
    [
      _c(
        "div",
        {
          staticClass: "room-menu",
          style: {
            backgroundColor: _vm.ux.menuColorId || "#5599ff",
          },
        },
        [
          _c("div", { staticClass: "room-menu-header" }, [
            _c("div", { staticClass: "setting" }, [
              _c("img", {
                staticClass: "absolute pointer-events-none",
                style: _vm.ux.logoImagePath
                  ? {
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      inset: 0,
                    }
                  : {
                      width: "34px",
                      height: "auto",
                    },
                attrs: {
                  src:
                    _vm.ux.logoImagePath ||
                    require("@/assets/images/logo_gooroomee_white.svg"),
                },
              }),
              _c("button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.right",
                    value: _vm.$t("menu.setting"),
                    expression: "$t('menu.setting')",
                    modifiers: { right: true },
                  },
                ],
                staticClass: "setting-button",
                on: {
                  click: function ($event) {
                    return _vm.onToggleSettingModal()
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "room-menu-body" }, [
            _c(
              "div",
              {
                staticClass: "timer",
                on: {
                  click: (e) => {
                    let now = Date.now()
                    if (now - (e.target._last_time || 0) > 2000) {
                      e.target._cnt = 0
                    }
                    e.target._last_time = now
                    e.target._cnt++
                    if (e.target._cnt >= 5) {
                      e.target._cnt = 0
                      _vm.toggleConnectionStats({
                        window: e.shiftKey,
                      })
                    }
                  },
                },
              },
              [_c("span", { ref: "roomTimer", staticClass: "timer-text" })]
            ),
            _c("ul", { staticClass: "room-menu-list" }, [
              _c("li", { staticClass: "room-menu-item" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.right",
                        value: _vm.$t("common.call"),
                        expression: "$t('common.call')",
                        modifiers: { right: true },
                      },
                    ],
                    staticClass: "room-menu-button",
                    class: {
                      selected: _vm.roomMode === "call",
                      disabled:
                        _vm.isRoomModeExam ||
                        (!_vm.isOpener() && _vm.isParticipantRole()),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onClickMenu("call")
                      },
                    },
                  },
                  [
                    _c("GrmIcon", {
                      attrs: { icon: "menu-call-white", size: "full" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm.useScreenShare
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.screenShareTooltipMsg,
                            expression: "screenShareTooltipMsg",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          selected: _vm.isRoomMode("screenShare"),
                          disabled:
                            _vm.isRoomModeExam ||
                            (_vm.isWebinarLive && !_vm.hasSpeakerRole()) ||
                            !_vm.screenShareRole ||
                            _vm.Device.isMobile() ||
                            _vm.Device.isTablet(),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickMenu("screenShare")
                          },
                        },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: {
                            icon: "menu-screenshare-white",
                            size: "full",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useDocShare
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.doc"),
                            expression: "$t('common.doc')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          selected: _vm.roomMode === "doc",
                          disabled:
                            _vm.isRoomModeExam ||
                            (!_vm.isOpener() && _vm.isParticipantRole()),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickMenu("doc")
                          },
                        },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: { icon: "menu-docshare-white", size: "full" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useMediaShare
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.mediaShare"),
                            expression: "$t('common.mediaShare')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          selected: _vm.roomMode === "media",
                          disabled:
                            _vm.isRoomModeExam ||
                            (!_vm.isOpener() && _vm.isParticipantRole()),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickMenu("media")
                          },
                        },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: {
                            icon: "menu-mediashare-white",
                            size: "full",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useMirroring
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.mirroring"),
                            expression: "$t('common.mirroring')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          selected: _vm.roomMode === "mirroring",
                          disabled:
                            _vm.isRoomModeExam ||
                            (!_vm.isOpener() && _vm.isParticipantRole()),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickMenu("mirroring")
                          },
                        },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: { icon: "menu-docshare-white", size: "full" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useMeetingNote
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.meetingNote"),
                            expression: "$t('common.meetingNote')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          disabled:
                            _vm.isRoomModeExam ||
                            (!_vm.isOpener() && _vm.isParticipantRole()),
                        },
                        on: { click: _vm.onToggleMeetingNote },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: {
                            icon: `menu-meeting-note-${
                              _vm.isOngoingMeetingNote ? "on" : "off"
                            }`,
                            size: "full",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useExam
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.right",
                          value: _vm.$t("common.exam"),
                          expression: "$t('common.exam')",
                          modifiers: { right: true },
                        },
                      ],
                      staticClass: "room-menu-button exam",
                      class: {
                        selected: _vm.isRoomModeExam,
                        disabled: !_vm.isOpener() && _vm.isParticipantRole(),
                      },
                      on: { click: _vm.onToggleExamModal },
                    }),
                  ])
                : _vm._e(),
              _vm.useCbt
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.right",
                          value: _vm.$t("common.CBT"),
                          expression: "$t('common.CBT')",
                          modifiers: { right: true },
                        },
                      ],
                      staticClass: "room-menu-button exam",
                      class: {
                        selected: _vm.roomMode === "CBT",
                        disabled: !_vm.isOpener() && _vm.isParticipantRole(),
                      },
                      on: { click: _vm.onToggleCBTModal },
                    }),
                  ])
                : _vm._e(),
              _vm.useSticker
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.right",
                          value: _vm.$t("menu.sticker"),
                          expression: "$t('menu.sticker')",
                          modifiers: { right: true },
                        },
                      ],
                      staticClass: "room-menu-button sticker",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "update:isOpenRoomStickerModal",
                            !_vm.isOpenRoomStickerModal
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm.isWebinarLive && _vm.useQnA
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.qna"),
                            expression: "$t('common.qna')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button qna",
                        on: { click: _vm.onToggleQnAModal },
                      },
                      [
                        _vm.questionList.length > 0
                          ? _c(
                              "span",
                              { staticClass: "qna-count-badge qna-count" },
                              [_vm._v(_vm._s(_vm.questionList.length))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.useAttendanceList
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.attendance"),
                            expression: "$t('common.attendance')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          disabled: !_vm.isOpener() && _vm.isParticipantRole(),
                        },
                        on: { click: _vm.onToggleAttendanceModal },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: {
                            icon: "menu-attendance-white",
                            size: "full",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useWaitingRoom
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.waitingRoom"),
                            expression: "$t('common.waitingRoom')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        class: {
                          badge: _vm.unchecked,
                          disabled: !_vm.isOpener() && _vm.isParticipantRole(),
                        },
                        on: { click: _vm.onToggleWaitingModal },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: { icon: "menu-waiting-white", size: "full" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useAIChatBot
                ? _c("li", { staticClass: "room-menu-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: _vm.$t("common.chatBot"),
                            expression: "$t('common.chatBot')",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "room-menu-button",
                        on: { click: _vm.onToggleChatBotModal },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: { icon: "menu-chat-bot", size: "full" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "room-menu-footer" }, [
            _c("div", { staticClass: "exit" }, [
              _c("button", {
                staticClass: "exit-button",
                on: { click: _vm.exitRoom },
              }),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }